export default angular.module('TrialApp', ['KhBase', 'articles_factories']);
